export const msgType = {
  email: 1,
  voice: 2,
  sms: 4,
}
